// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4549":"4b5114c4","4872":"9b7163db"}[chunkId] + ".chunk.css";
};